import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    passwordResetConfirm: false,
    error: false,
    errorPhrase: ""
}

const passwordResetSlice = createSlice({
    name: "passwordReset",
    initialState,
    reducers: {
        passwordResetConfirm: (state) => {
            state.passwordResetConfirm = true
        },
        passwordResetError: (state, action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        reset: state => initialState,
    },
})

export const { passwordResetConfirm, passwordResetError, reset } = passwordResetSlice.actions
export default passwordResetSlice.reducer